/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { DatePicker } from 'sarsaparilla';
import { gnoment, calendarDateToGnoment, gnomentToCalendarDate } from 'shared-ui/gnoment';

// Note: this file is the one used by EXTERNAL permits
export default class SingleDatePickerCalendar extends React.Component {
    static propTypes = {
        availability: PropTypes.array,
        label: PropTypes.string,
        isInvalid: PropTypes.bool,
        selectedDate: PropTypes.any,
        handleDateChange: PropTypes.func,
        id: PropTypes.string,
    };

    static defaultProps = {
        availability: [],
        selectedDate: {},
        isInvalid: false,
    };

    getDayType = (day) => {
        const date = calendarDateToGnoment(day);

        return this.isDayBlocked(date) ? 'blocked' : 'available';
    };

    getRawAvailableStartDateRange = () => {
        let availableStartDates = [];
        this.props.availability.forEach((a) => {
            availableStartDates = [...availableStartDates, ...a.start_date.split(';')];
        });

        return availableStartDates;
    };

    getInitialMonth = () => {
        // get month of selectedDate
        const { selectedDate } = this.props;
        if (!isEmpty(selectedDate)) {
            return gnoment(selectedDate);
        }

        // get earliest date available
        const sortedAvailableDates = this.getRawAvailableStartDateRange().sort(
            (a, b) => new Date(a) - new Date(b)
        );
        return gnoment(sortedAvailableDates[0]);
    };

    isDayBlocked = (day) =>
        !this.getRawAvailableStartDateRange().includes(gnoment(day).format('YYYY-MM-DD'));

    getDatePickerDefaultValue = () => {
        return isEmpty(this.props.selectedDate)
            ? null
            : gnomentToCalendarDate(gnoment(this.props.selectedDate).utc());
    };

    onHandleDateChange = (value, validationObject) => {
        let date = null;

        if (value && !validationObject?.isInvalid) {
            const dateUpdated = calendarDateToGnoment(value);

            date = gnoment(dateUpdated).utc().startOf('day');
        }

        this.props.handleDateChange(date, this.props.id);
    };

    getUnavailableDate = (day) => {
        const date = calendarDateToGnoment(day);

        return this.isDayBlocked(date, this.props);
    };

    render() {
        return (
            <DatePicker
                style={{ minWidth: '14rem', maxWidth: '14rem' }}
                isInvalid={this.props.isInvalid}
                label={this.props.label}
                isLabelVisible={false}
                showClearDates={false}
                defaultValue={this.getDatePickerDefaultValue()}
                id={this.props.id ? this.props.id : 'selectedDateId'}
                placeholderValue={gnomentToCalendarDate(this.getInitialMonth())}
                onChange={this.onHandleDateChange}
                isDateUnavailable={(day) => this.getUnavailableDate(day)}
                getDayType={this.getDayType}
            />
        );
    }
}
